/***************************************************************************************************
 * Zone JS is required for the tests.
 */
import 'zone.js/dist/zone'; // Included with Angular CLI.
(window as any).global = globalThis;
